import {RouteInfo} from './sidebar.metadata';


export const ROUTES: RouteInfo[] = [
  {
    path: '',
    title: 'operations',
    icon: '',
    class: 'header',
    groupTitle: true,
    submenu: [],
      showMenu: false
  },
  {
    path: 'dashboard',
    title: 'Dashboard',
    icon: 'pie-chart',
    class: '',
    groupTitle: false,
    submenu: [],
      showMenu: false
  },
  {
    path: 'dashboard',
    title: 'Dashboards',
    icon: 'pie-chart',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: '/home/mis-counselling',
        title: 'Counselling Dashboard',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/mis-donation',
        title: 'Donation Dashboard',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/mis-education',
        title: 'Education Dashboard',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/mis-transport',
        title: 'Transport Dashboard',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/mis-operations',
        title: 'Operation Dashboard',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      }
    ]
  },
  {
    path: 'home',
    title: 'Child Master',
    icon: 'file-text',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      // {
      //   path: 'dashboard',
      //   title: 'Dashboard',
      //   icon: 'sidebar',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   submenu: []
      // },
      {
          path: 'child-admission/child-list',
          title: 'Child Admission',
          icon: 'smile',
          class: 'ml-menu',
          groupTitle: false,
          submenu: [],
          showMenu: false,
      },
      {
        path: 'child-list/list',
        title: 'Child List',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        submenu: [],
        showMenu: false,
      },
      {
        path: 'prescreening/prescreening',
        title: 'Prescreening List',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/highlight',
        title: 'Child Highlights',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/child-case-study',
        title: 'Case Study',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      }, {
        path: '/home/feedback/child-calling-follow-up',
        title: 'Child Call And Follow-Up',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'Units',
        title: 'Units',
        icon: 'sidebar',
        class: 'ml-menu',


        groupTitle: false,
        showMenu: false,
        submenu: []
      },


    ]
  },
  {
    path: 'counseling',
    title: 'Counselling',
    icon: 'mic',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: 'counseling/individual',
        title: 'Individual Sessions',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/group',
        title: 'Group Sessions',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/assessments',
        title: 'Assessments',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/follow-up-table',
        title: 'Follow Up Assessments',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'questions/counselling-question-list',
        title: 'Follow Up Questions',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: '',
      //   title: 'Follow Up',
      //   icon: 'sidebar',
      //   class: 'menu-toggle',
      //
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: [
      //
      //   ]
      // },
      {
        path: 'counseling/reports',
        title: 'Reports',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ]
  },
  {
    path: 'counseling',
    title: 'Counselling Depository',
    icon: 'mic',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: 'counseling/counselling-session-reviews-list',
        title: 'Counselling Observation',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/work-update-list',
        title: 'Work Updates',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/counselling-sop',
        title: 'Counselling Sop',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/group-session-topics-list',
        title: 'Group Session Topics',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/counselling-mom-list',
        title: 'Counselling MOM',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/counselling-induction-list',
        title: 'Counselling Induction',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/counselling-highlight-list',
        title: 'Counselling Highlight',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/counselling-center-log',
        title: 'Counselling Center Log',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/counselling-presentation-list',
        title: 'Counselling Presentation',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ],
  },
  {
    path: '',
    title: 'Counselling Reports',
    icon: 'trello',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [

      {
        path: 'reports/impact-report-counseling-table',
        title: 'Counseling Impact Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/challenges',
        title: 'Challenges Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'counseling/reports',
        title: 'Progress Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },

      {
        path: 'reports/intervention',
        title: 'Intervention Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/comparison',
        title: 'Comparison',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/counselling-count-report',
        title: 'Cou. Session Count',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/follow-up-overview2',
        title: 'Followup Overview',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: 'counseling/reports',
      //   title: 'Progress Reports',
      //   icon: 'sidebar',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: true,
      //   submenu: []
      // },
    ]
  },
//Education
  {
    path: 'education',
    title: 'Education',
    icon: 'book-open',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: 'education/individual',
        title: 'Individual Session',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'education/group',
        title: 'Group Session',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: 'education/education-report',
      //   title: 'Education Reports',
      //   icon: 'sidebar',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      {
        path: 'education/follow-up-table',
        title: 'Follow Up Assessment',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'questions/education-question-list',
        title: 'Follow Up Question',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ]
  },
  {
    path: 'education',
    title: 'Education Depository',
    icon: 'book-open',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: 'education/education-observation-list',
        title: 'Education Observation',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'education/work-update-list',
        title: 'Daily Work Update',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'education/education-sop',
        title: 'Education SOP',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'education/induction-list',
        title: 'Education Induction',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'education/special-day-list',
        title: 'Special Day',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'education/education-mom-list',
        title: 'Education MOM',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'education/education-highlight-list',
        title: 'Education Highlight',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/education-presentation-list',
        title: 'Education Presentation',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ]
  },
  {
    path: '',
    title: 'Education Reports',
    icon: 'trello',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [


      {
        path: 'reports/impact-report-table',
        title: 'Education Impact Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/report-card-table',
        title: 'Report Card',
        icon: 'bar-chart',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },


      {
        path: 'reports/attendance',
        title: 'Analytical Report',
        icon: 'book',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/education-count-report',
        title: 'Edu. Session Count',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/education-overview',
        title: 'Follow Up Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/education-mis-report',
        title: 'MIS Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ]
  },
  {
    path: '#',
    title: 'Operations Dept',
    class: 'menu-toggle',
    icon:'git-branch',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: '/home/reports/highlight-list',
        title: 'Centre Highlights',
        icon: 'truck',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/feedback/feedback-list',
        title: 'Feedback',
        icon: 'help-circle',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/testimonials/list',
        title: 'Testimonials',
        icon: 'message-square',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },

      {
        path: '/home/meals',
        title: 'Mealmate',
        icon: 'coffee',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      //  {
      //   path: '/home/meals/bookings',
      //   title: 'Bookings',
      //   icon: 'smartphone',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // }


    {
        path: '/home/unitsponsorship',
        title: 'Unit Sponsorship',
        icon: 'dollar-sign',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },

    {
        path: '/home/Events',
        title: 'Events',
        icon: 'framer',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },


    {
        path: '/home/inventory/contact_tbl',
        title: 'Contacts',
        icon: 'user',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },



    ],
  },


  {
    path: 'inventory',
    title: 'Inventory',
    icon: 'shopping-bag',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [


      {
        path: 'inventory/products',
        title: 'Products',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'inventory/purchase_product_tbl',
        title: 'Instock Entry',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },


      {
        path: 'inventory/centreInventory',
        title: 'Centre Inventory',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'inventory/types',
        title: 'Inventory Category',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },


      {
        path: 'inventory/stock_adjustment',
        title: 'Stock Adjustment',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: 'inventory/stock_adjustment_view',
      //   title: 'Stock Adjustment view',
      //   icon: 'sidebar',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      {
        path: 'inventory/IncomingOutgoingTransfer',
        title: 'Stock Transfer',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //       path: 'inventory/inventory_report',
      //       title: 'Inventory Report',
      //       icon: 'sidebar',
      //       class: 'ml-menu',
      //       groupTitle: false,
      //       submenu: []
      //   },
      {
        path: 'inventory/direct-issue-table',
        title: 'Direct Issue',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'inventory/inventory-requests',
        title: 'Request Products',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },


      //{
      //   path: 'inventory/request_product_new',
      //   title: 'Request Product',
      //   icon: 'sidebar',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      //}


      {
        path: 'inventory/issue_tbl',
        title: 'Issue Requests',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: 'inventory/Issued_product_list',
      //   title: 'Issued Products',
      //   icon: 'sidebar',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      {
        path: 'inventory/purchase-list',
        title: 'Purchase List',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'inventory/hygiene-kit',
        title: 'Hygiene Kit',
        icon: 'sidebar',
        class: 'ml-menu',
        showMenu: false,


        groupTitle: false,
        submenu: []
      },
      {
        path: 'inventory/inventory-product-history',
        title: 'Inventory Log',
        icon: 'sidebar',
        class: 'ml-menu',
        showMenu: false,
        groupTitle: false,
        submenu: []
      },
      {
        path: 'inventory/daily-inventory-count-report',
        title: 'Daily Inventory Count Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'inventory/inventory-tracking-report',
        title: 'Inventory Tracking Report',
        icon: 'receipt',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ]
  },


  // Transport
  {
    path: '#',
    title: 'Transport',
    icon: 'Truck',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: '/home/vehicles/driver-table',
        title: 'Drivers',
        icon: 'truck',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/vehicles/vehicle-table',
        title: 'Vehicles',
        icon: 'Truck',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/vehicles/car-log-book',
        title: 'Trip Log',
        icon: 'Truck',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/vehicles/fuels-details',
        title: 'Fuel Filling Log',
        icon: 'Truck',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/vehicles/servicing-details',
        title: 'Servicing Log',
        icon: 'Truck',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ]
  },


  {
    path: '',
    title: 'Donation Reports',
    icon: 'trello',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: 'donation',
        title: 'Donation Report',
        icon: 'gift',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'attempted-donations',
        title: 'Attempted Donations',
        icon: 'gift',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'failed-donations',
        title: 'Failed Donations',
        icon: 'gift',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'razorpay-data',
        title: 'Razorpay Payments',
        icon: 'dollar-sign',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'donations',
        title: 'Custom Payments',
        icon: 'dollar-sign',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: 'donations/custom-payments',
      //   title: 'Custom Payments',
      //   icon: 'dollar-sign',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
    ]
  },



  {
    path: '',
    title: 'Ops Reports',
    icon: 'trello',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [

      {
        path: 'reports/child-report',
        title: 'Child Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/admission-report',
        title: 'Admission Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/admission-count-report',
        title: 'Admission Yearly Report', //Admission Count Report
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },


      {
        path: 'reports/daily-child-occupancy',
        title: 'Daily Child Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/weekly-report',
        title: 'Weekly Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/occupancy-report',
        title: 'Occupancy Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/efficiency-report',
        title: 'Efficiency Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'quarterly-report',
        title: 'Quarterly Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/units',
        title: 'Unit & Floor Report',
        icon: 'clock',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/age-group',
        title: 'Age Group Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/hospital-count-report',
        title: 'Hospital Count Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/hospital-wise-occupancy',
        title: 'Hospital Wise Occ.',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/hospitals',
        title: 'Child Wise Hospital',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/location-state-report',
        title: 'State Count Report',
        icon: 'clock',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/average-stay-report',
        title: 'Average Stay Report',
        icon: 'clock',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/om-shanti-report',
        title: 'Om Shanti Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: 'reports/child-case-study',
      //   title: 'Case Study',
      //   icon: 'trello',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      // {
      //   path: 'reports/highlight',
      //   title: 'Highlight',
      //   icon: 'trello',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      {
        path: 'reports/treatment-duration',
        title: 'Duration Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/allergy-type-report',
        title: 'Allergy Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/gender-report',
        title: 'Gender Count Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/count-report',
        title: 'Yearly Count Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/blood-group-report',
        title: 'Blood Group Report',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'reports/admission-log-history',
        title: 'Admission Log History',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ]
  },



  // {
  //   path: '',
  //   title: 'Donation',
  //   icon: 'gift',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   showMenu: false,
  //   submenu: [
  //     {
  //       path: 'meals',
  //       title: 'Mealmate',
  //       icon: 'trello',
  //       class: '',
  //       groupTitle: false,
  //       showMenu: false,
  //       submenu: []
  //     },
  //     {
  //       path: 'meals/bookings',
  //       title: 'Bookings',
  //       icon: 'book',
  //       class: '',
  //       groupTitle: false,
  //       showMenu: false,
  //       submenu: []
  //     },
  //     {
  //       path: 'unitsponsorship',
  //       title: 'Unit Sponsorship',
  //       icon: 'trello',
  //       class: '',
  //       groupTitle: false,
  //       showMenu: false,
  //       submenu: []
  //     },
  //
  //
  //   ]
  // },

  {
    path: 'reminders',
    title: 'Reminders',
    icon: 'clock',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: '/home/payments',
        title: 'Payments',
        icon: 'clock',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/followup-admissions',
        title: 'Followups',
        icon: 'clock',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/reports/birthday-report',
        title: 'Birthdays',
        icon: 'trello',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },


    ]
  },
  // {
  //   path: 'CMS',
  //   title: 'CMS',
  //   icon: 'chrome',
  //   class: '',
  //   groupTitle: false,
  //   showMenu: false,
  //   submenu: []
  // },



  {
    path: '#',
    title: 'Tasks',
    icon: 'check-circle',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: '/home/tasks',
        title: 'Tasks',
        icon: 'check-circle',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ]
  },
  {
    path: '/home/dms',
    title: 'DMS',
    icon: 'database',
    class: '',
    groupTitle: false,
    showMenu: false,
    submenu: []
  },
  {
    path: '#',
    title: 'Depository',
    class: 'menu-toggle',
    icon:'chrome',
    groupTitle: false,
    showMenu: false,
    submenu: [
       {
        path: '/home/award/award-recognition-list',
        title: 'Award Recognition',
        icon: 'award',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/membership/membership-list',
        title: 'Membership',
        icon: 'credit-card',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/hospitals',
        title: 'Hospitals',
        icon: 'activity',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },

      {
        path: '/home/media/media-coverage-list',
        title: 'Media Coverages',
        icon: 'youtube',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/volunteer/list-volunteers',
        title: 'Volunteer',
        icon: 'globe',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/mom/mom-list',     // FAKE URL
        title: 'Minutes of Meeting',
        icon: 'watch',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/inquiry-8080/inquiry-list',     // FAKE URL
        title: '8080 Enquiry',
        icon: 'activity',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/sop/sop-list',
        title: 'Resource Repository',
        icon: 'database',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },

      {
        path: '/home/staff-learning/staff-learning-list',
        title: 'Staff Learning Sessions',
        icon: 'book-open',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },

      {
        path: '/home/email/email-dashboard',
        title: 'Email',
        icon: 'mail',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: 'photo-gallery',
        title: 'Photo Gallery',
        icon: 'image',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },

    ],
  },
  {
    path: '#',
    title: 'Ticketing',
    class: 'menu-toggle',
    icon:'chrome',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: '/home/ticketing/ticket-list',
        title: 'Ticket List',
        icon: 'award',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
    ],
  },
  {
    path: '/home/agreements',
    title: 'Rental Agreements',
    icon: 'file-text',
    class: '',
    groupTitle: false,
    showMenu: false,
    submenu: []
  },
  {
    path: '#',
    title: 'Donor Management',
    icon: 'command',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [

      {
        path: '/home/Donor',
        title: 'Donor Profile',
        icon: 'umbrella',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/Donor/visitor-profile',
        title: 'Visitor Profile',
        icon: 'users',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },

    ]
  },
  {
    path: 'reports/annual-impact-report',
    title: 'AI Powered Impact Report',
    icon: 'umbrella',
    class: '',
    groupTitle: false,
    showMenu: false,
    submenu: []
  },
  {
    path: 'reports/narrative-impact-report',
    title: 'Narrative Impact Report',
    icon: 'slack',
    class: '',
    groupTitle: false,
    showMenu: false,
    submenu: []
  },

  {
    path: '#',
    title: 'Masters',
    icon: 'command',
    class: 'menu-toggle',
    groupTitle: false,
    showMenu: false,
    submenu: [
      {
        path: '/home/allcentres',
        title: 'Centres',
        icon: 'umbrella',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/users',
        title: 'Users',
        icon: 'users',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: '/home/edit-roles-permissions',
      //   title: 'Edit Permissions',
      //   icon: 'users',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      // {
      //   path: '/home/hospitals',
      //   title: 'Hospitals',
      //   icon: 'activity',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },

      // {
      //   path: '/home/volunteer/list-volunteers',
      //   title: 'Volunteer',
      //   icon: 'users',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      {
        path: 'types',
        title: 'Types',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/prefix/prefix_master_list',
        title: 'Prefix Master',
        icon: 'users',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      {
        path: '/home/media/media-coverage-list',
        title: 'Media',
        icon: 'users',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: '/home/award/award-recognition-list',
      //   title: 'Award Recognition',
      //   icon: 'users',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      // {
      //   path: '/home/membership/membership-list',
      //   title: 'Membership',
      //   icon: 'users',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      {
        path: 'glossary',
        title: 'Glossary',
        icon: 'sidebar',
        class: 'ml-menu',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },
      // {
      //   path: '/home/Donor',
      //   title: 'Donor',
      //   icon: 'gift',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      // {
      //   path: '/home/Events',
      //   title: 'Events',
      //   icon: 'sidebar',
      //   class: '',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      // {
      //   path: 'inventory/contact_tbl',
      //   title: 'Contacts',
      //   icon: 'sidebar',
      //   class: 'ml-menu',
      //   groupTitle: false,
      //   showMenu: false,
      //   submenu: []
      // },
      {
        path: '/home/activitylog',
        title: 'Audit Logs',
        icon: 'sidebar',
        class: '',
        groupTitle: false,
        showMenu: false,
        submenu: []
      },


    ]
  },

  // {
  //   path: '#',
  //   title: 'Feedback',
  //   icon: 'command',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   showMenu: false,
  //   submenu: [
  //     {
  //       path: '/home/feedback/child-calling-follow-up',
  //       title: 'Child Call And Follow-Up',
  //       icon: 'umbrella',
  //       class: '',
  //       groupTitle: false,
  //       showMenu: false,
  //       submenu: []
  //     },
  //   ]
  // }


  // {
  //   path: 'contacts',
  //   title: 'MENUITEMS.CONTACTS.TEXT',
  //   icon: 'users',
  //   class: '',
  //   groupTitle: false,
  //   submenu: []
  // },
  // {
  //   path: '',
  //   title: 'MENUITEMS.EMAIL.TEXT',
  //   icon: 'mail',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/email/inbox',
  //       title: 'MENUITEMS.EMAIL.LIST.INBOX',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/email/compose',
  //       title: 'MENUITEMS.EMAIL.LIST.COMPOSE',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/email/read-mail',
  //       title: 'MENUITEMS.EMAIL.LIST.READ',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  //
  // {
  //   path: '',
  //   title: 'MENUITEMS.MORE-APPS.TEXT',
  //   icon: 'command',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/apps/chat',
  //       title: 'MENUITEMS.MORE-APPS.LIST.CHAT',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/apps/dragdrop',
  //       title: 'MENUITEMS.MORE-APPS.LIST.DRAG-DROP',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/apps/contact-grid',
  //       title: 'MENUITEMS.MORE-APPS.LIST.CONTACT-GRID',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/apps/support',
  //       title: 'MENUITEMS.MORE-APPS.LIST.SUPPORT',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'MENUITEMS.COMPONENTS.TEXT',
  //   icon: '',
  //   class: 'header',
  //   groupTitle: true,
  //   submenu: []
  // },
  // {
  //   path: '',
  //   title: 'MENUITEMS.WIDGETS.TEXT',
  //   icon: 'briefcase',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/widget/chart-widget',
  //       title: 'MENUITEMS.WIDGETS.LIST.CHART-WIDGET',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/widget/data-widget',
  //       title: 'MENUITEMS.WIDGETS.LIST.DATA-WIDGET',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'MENUITEMS.FORMS.TEXT',
  //   icon: 'layout',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/forms/form-controls',
  //       title: 'MENUITEMS.FORMS.LIST.CONTROLS',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/advance-controls',
  //       title: 'MENUITEMS.FORMS.LIST.ADVANCE',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/form-example',
  //       title: 'MENUITEMS.FORMS.LIST.EXAMPLE',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/form-validation',
  //       title: 'MENUITEMS.FORMS.LIST.VALIDATION',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/wizard',
  //       title: 'MENUITEMS.FORMS.LIST.WIZARD',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/forms/editors',
  //       title: 'MENUITEMS.FORMS.LIST.EDITORS',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'MENUITEMS.TABLES.TEXT',
  //   icon: 'grid',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/tables/basic-tables',
  //       title: 'MENUITEMS.TABLES.LIST.BASIC',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/tables/material-tables',
  //       title: 'MENUITEMS.TABLES.LIST.MATERIAL',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/tables/ngx-datatable',
  //       title: 'MENUITEMS.TABLES.LIST.NGX-DATATABLE',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Charts',
  //   icon: 'pie-chart',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/charts/echart',
  //       title: 'Echart',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/charts/apex',
  //       title: 'Apex',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/charts/chartjs',
  //       title: 'ChartJS',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/charts/ngx-charts',
  //       title: 'Ngx-Charts',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/charts/gauge',
  //       title: 'Gauge',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'User Interface (UI)',
  //   icon: 'copy',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/ui/alerts',
  //       title: 'Alerts',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/badges',
  //       title: 'Badges',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/chips',
  //       title: 'Chips',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/modal',
  //       title: 'Modal',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/buttons',
  //       title: 'Buttons',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/expansion-panel',
  //       title: 'Expansion Panel',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/bottom-sheet',
  //       title: 'Bottom Sheet',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/dialogs',
  //       title: 'Dialogs',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/cards',
  //       title: 'Cards',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/labels',
  //       title: 'Labels',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/list-group',
  //       title: 'List Group',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/snackbar',
  //       title: 'Snackbar',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/preloaders',
  //       title: 'Preloaders',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/progressbars',
  //       title: 'Progress Bars',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/tabs',
  //       title: 'Tabs',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/typography',
  //       title: 'Typography',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/ui/helper-classes',
  //       title: 'Helper Classes',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Icons',
  //   icon: 'feather',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/icons/material',
  //       title: 'Material Icons',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/icons/font-awesome',
  //       title: 'Font Awesome',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/icons/simple-line',
  //       title: 'Simple Line Icons',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/icons/themify',
  //       title: 'Themify Icons',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Maps',
  //   icon: 'map-pin',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/maps/google',
  //       title: 'Google Map',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'EXTRA',
  //   icon: '',
  //   class: 'header',
  //   groupTitle: true,
  //   submenu: []
  // },
  // {
  //   path: '',
  //   title: 'Timeline',
  //   icon: 'git-pull-request',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/timeline/timeline1',
  //       title: 'Timeline 1',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/timeline/timeline2',
  //       title: 'Timeline 2',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Medias',
  //   icon: 'image',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/media/gallery',
  //       title: 'Image Gallery',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Authentication',
  //   icon: 'user-check',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/authentication/signin',
  //       title: 'Sign In',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/signup',
  //       title: 'Sign Up',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/forgot-password',
  //       title: 'Forgot Password',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/locked',
  //       title: 'Locked',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/page404',
  //       title: '404 - Not Found',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/authentication/page500',
  //       title: '500 - Server Error',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Extra Pages',
  //   icon: 'anchor',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/extra-pages/profile',
  //       title: 'Profile',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/extra-pages/pricing',
  //       title: 'Pricing',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/extra-pages/invoice',
  //       title: 'Invoice',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/extra-pages/faqs',
  //       title: 'Faqs',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/extra-pages/blank',
  //       title: 'Blank Page',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   title: 'Multi level Menu',
  //   icon: 'chevrons-down',
  //   class: 'menu-toggle',
  //   groupTitle: false,
  //   submenu: [
  //     {
  //       path: '/multilevel/first1',
  //       title: 'First',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/',
  //       title: 'Second',
  //       icon: '',
  //       class: 'ml-sub-menu',
  //       groupTitle: false,
  //       submenu: [
  //         {
  //           path: '/multilevel/secondlevel/second1',
  //           title: 'Second 1',
  //           icon: '',
  //           class: 'ml-menu2',
  //           groupTitle: false,
  //           submenu: []
  //         },
  //         {
  //           path: '/',
  //           title: 'Second 2',
  //           icon: '',
  //           class: 'ml-sub-menu2',
  //           groupTitle: false,
  //           submenu: [
  //             {
  //               path: '/multilevel/thirdlevel/third1',
  //               title: 'third 1',
  //               icon: '',
  //               class: 'ml-menu3',
  //               groupTitle: false,
  //               submenu: []
  //             }
  //           ]
  //         }
  //       ]
  //     },
  //     {
  //       path: '/multilevel/first3',
  //       title: 'Third',
  //       icon: '',
  //       class: 'ml-menu',
  //       groupTitle: false,
  //       submenu: []
  //     }
  //   ]
  // }

];









